import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Sparkles, ArrowLeft } from "lucide-react";
import api from "@/lib/api";
import DoctorShell from "@/components/DoctorShell";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export default function ComingSoon() {
    const [sp] = useSearchParams();
    const featureCode = sp.get("code") || "";
    const navigate = useNavigate();
    const [entitlements, setEntitlements] = useState(null);
    const [doctor, setDoctor] = useState(null);

    useEffect(() => {
        Promise.all([
            api.get("/me/entitlements"),
            api.get("/me/doctor").catch(() => ({ data: null })),
        ]).then(([e, d]) => {
            setEntitlements(e.data);
            setDoctor(d.data);
        });
    }, []);

    const item = entitlements?.items.find((i) => i.feature_code === featureCode);

    return (
        <DoctorShell doctor={doctor}>
            <div className="max-w-2xl mx-auto py-12" data-testid="coming-soon-page">
                <Button variant="ghost" onClick={() => navigate(-1)} className="mb-4" data-testid="coming-soon-back">
                    <ArrowLeft size={16} className="mr-2" /> Back
                </Button>
                <Card className="border-[#123B5D]/10">
                    <CardContent className="p-10 text-center">
                        <div className="w-16 h-16 rounded-full bg-[#0F766E]/10 mx-auto mb-4 flex items-center justify-center">
                            <Sparkles size={32} className="text-[#0F766E]" />
                        </div>
                        <div className="text-xs uppercase tracking-widest text-[#0F766E] mb-2" data-testid="coming-soon-code">{featureCode}</div>
                        <h2 className="text-2xl font-bold text-[#123B5D]" data-testid="coming-soon-title">
                            {item?.name || "Coming soon"}
                        </h2>
                        <p className="text-[#17212B]/70 mt-3">
                            This module is unlocked on your plan and is currently under active development.
                            You'll be notified as soon as it goes live.
                        </p>
                        <div className="mt-6 text-xs text-[#17212B]/50">
                            Meanwhile, you can continue using the other unlocked modules from the sidebar.
                        </div>
                    </CardContent>
                </Card>
            </div>
        </DoctorShell>
    );
}
